<template>
  <div class="maintenance-page">
    <div class="maintenance-card">
      <div class="maintenance-icon" aria-hidden="true">
        <svg
          class="maintenance-icon-svg"
          viewBox="0 0 64 64"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 26.5C22 20.7 26.7 16 32.5 16C38.3 16 43 20.7 43 26.5V35.6C43 37.6 43.8 39.5 45.1 40.9L47 43H18L19.9 40.9C21.2 39.5 22 37.6 22 35.6V26.5Z"
          />
          <path d="M30 48C30.5 49.8 31.9 51 33.5 51C35.1 51 36.5 49.8 37 48" />
          <path d="M32.5 12V14.5" />
        </svg>
      </div>

      <h1 class="maintenance-title">Sistema en mantenimiento</h1>

      <div class="maintenance-content">
        <p>
          Actualmente nuestro sistema presenta una incidencia y estamos
          trabajando para solucionarla con la maxima urgencia.
        </p>
        <p>
          Si durante este periodo la incidencia provoca retrasos en los pedidos
          y genera cargos adicionales, dichos cargos seran exonerados en su
          totalidad. Le agradecemos su paciencia.
        </p>
        <p>
          Si tiene cualquier otra consulta, por favor contacte con el servicio
          de atencion al cliente: 918055475.
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue';

export default defineComponent({
  name: 'announcementPage',
  setup() {
    onMounted(() => {
      document.title = 'Sistema en mantenimiento';
    });

    return {};
  }
});
</script>

<style lang="scss" scoped>
.maintenance-page {
  width: 100vw;
  min-height: 100vh;
  margin-left: calc(50% - 50vw);
  padding: 36px 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(circle at top center, rgba(145, 208, 255, 0.14), transparent 34%),
    linear-gradient(180deg, #f6f8fc 0%, #eef3fb 100%);
}

.maintenance-card {
  width: 100%;
  max-width: 760px;
  padding: 42px 34px 48px;
  border-radius: 36px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0 22px 70px rgba(91, 108, 132, 0.12);
}

.maintenance-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 68px;
  height: 68px;
  margin: 0 auto 24px;
}

.maintenance-icon-svg {
  width: 100%;
  height: 100%;

  path {
    fill: none;
    stroke: #f06a00;
    stroke-width: 3;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
}

.maintenance-title {
  margin-bottom: 28px;
  color: #0f1115;
  font-family: Fredoka-Medium, serif;
  font-size: 40px;
  line-height: 1.18;
  text-align: center;
}

.maintenance-content {
  max-width: 536px;
  margin: 0 auto;
  color: #3e434d;
  font-family: Manrope-Medium, serif;
  font-size: 28px;
  line-height: 1.58;
  text-align: left;

  p + p {
    margin-top: 2px;
  }
}

@media (min-width: 1100px) {
  .maintenance-page {
    padding: 56px 28px;
  }

  .maintenance-card {
    max-width: 860px;
    padding: 56px 68px 60px;
    border-radius: 40px;
  }

  .maintenance-icon {
    width: 76px;
    height: 76px;
    margin-bottom: 28px;
  }

  .maintenance-title {
    margin-bottom: 34px;
    font-size: 50px;
  }

  .maintenance-content {
    max-width: 660px;
    font-size: 21px;
    line-height: 1.72;
  }
}

@media (max-width: 767px) {
  .maintenance-card {
    padding: 38px 32px 44px;
  }

  .maintenance-title {
    margin-bottom: 24px;
    font-size: 38px;
  }

  .maintenance-content {
    max-width: 100%;
    font-size: 24px;
    line-height: 1.56;
  }

  .maintenance-content p + p {
    margin-top: 2px;
  }
}
</style>
